import { t } from 'i18next';
import * as yup from 'yup';

export const addToJobSchema = () =>
  yup.object().shape({
    project: yup.object().label(t('labelProject')).nullable().required(),
    jobName: yup.string().label(t('labelJobName')).nullable().required(),
  });
